

import {Component, Prop, Vue} from "vue-property-decorator";
import PazClipboardButton from "../../../components/controls/PazClipboardButton.vue";
import PazTooltipButton from "../../../components/controls/PazTooltipButton.vue";
import PazConfirmation from "../../../components/utils/PazConfirmation.vue";
import PazTextSearch from "../../../components/controls/PazTextSearch.vue";
import PazAjaxTable from "../../../components/layout/PazAjaxTable.vue";
import PazRefreshButton from "../../../components/controls/PazRefreshButton.vue";
import {deleteRequiredDocument, getRequiredDocuments} from "../../../services/auth-service";
import {IRequiredDocument} from "../../../models/dossier.model";
import {DataTableHeader} from "vuetify";
import EditRequiredDocumentDialog from "./EditRequiredDocumentDialog.vue";

@Component({
  components: {
    PazClipboardButton,
    EditRequiredDocumentDialog,
    PazTooltipButton,
    PazConfirmation,
    PazTextSearch,
    PazAjaxTable,
    PazRefreshButton,
  },
})
export default class RequiredDocumentsOverview extends Vue {


  public loading: boolean = true;
  public showMaskInfo: boolean = false;
  @Prop({default: ''})
  public search!: string;
  public items: IRequiredDocument[] = [];

  // id: number;
  // name: string;
  // description?: string;
  // personal: boolean;
  // isMandatory: boolean;
  // isAdminOnly: boolean;
  // category: number|IRequiredDocumentCategory;
  // description?: string;
  // id?: number;
  // name: string;
  // sortindex: number;
  // statusMask?: string;

  public headers: DataTableHeader[] = [
    {
      text: "Category",
      align: "start",
      sortable: true,
      value: "category.sortindex",
    },
    {
      text: "Name",
      align: "start",
      sortable: true,
      value: "name",
    },
    {
      text: "Personal",
      align: "start",
      sortable: true,
      value: "personal",
    },
    {
      text: "Mandatory",
      align: "start",
      sortable: true,
      value: "isMandatory",
    },
    {
      text: "Admin only",
      align: "start",
      sortable: true,
      value: "isAdminOnly",
    },
    {
      text: "Action",
      align: "end",
      sortable: true,
      value: "extra",
    },
  ];
  showEditDialog: boolean = false;
  selectedId: number | null = null;


  $refs!: {
    confirm: PazConfirmation;
    response: PazConfirmation;
    confirmWarn: PazConfirmation;
  };


  async fetchData() {
    this.loading = true;
    this.items = await getRequiredDocuments({expand: 'category'});
    this.loading = false;
  }


  async confirmDeletion(entity: any) {

    const confirm = await this.$refs.confirm.openConfirmDialog(
        "Delete",
        "Are you sure you want to delete `" + entity.name + "`?"
    );
    if (confirm) {
      const response = await deleteRequiredDocument(entity.id);
      if (response) await this.fetchData();
    }
  }

  triggerEditDialog(id: number | null) {
    this.selectedId = id;
    this.showEditDialog = true;
  }

  toggleMaskInfo() {
    this.showMaskInfo = !this.showMaskInfo;
  }

  async showDetails(id: number) {
    await this.$router.push({path: `/groups/${id}`})
  }

  public mounted() {
    this.fetchData();
  }
}
